module.exports = __webpack_public_path__ + "static/assets/adf4a39b382abb54ec3967cdef9b392e.png";